<template>
  <div class="timeline-calendar__row">
    <div
      v-for="week in weeks"
      class="timeline-calendar__weeks timeline-calendar__item"
      :class="{ 'current-week': showCurrentDayIndicator && week.isCurrentWeek }"
      :data-grid-columns="gridColumnsCount(week)"
    >
      {{ week.week }}

      <c-tooltip v-if="showCurrentDayIndicator && week.isCurrentWeek"
        >Hudige week</c-tooltip
      >

      <c-timeline-current-week-indicator
        v-if="showCurrentDayIndicator && week.isCurrentWeek"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import CTimelineCurrentWeekIndicator from "shared/components/wrappers/timeline-calendar/CTimelineCurrentWeekIndicator.vue";

const model = defineModel({
  type: Object,
  required: true,
  default: () => ({}),
});

const props = defineProps({
  showCurrentDayIndicator: {
    type: Boolean,
    default: true,
  },
});

const weeks = computed(() => model.value.grid.value.weeks);
const gridColumnsCount = (week) => {
  return model.value.showDays ? week.days : 1;
};
</script>
